import request from '@/utils/request'


// 查询产品规格列表
export function listGoodsSpec(query) {
  return request({
    url: '/user/goods-spec/list',
    method: 'get',
    params: query
  })
}

/** 按商品查询 zb_goods_spec 下拉（id + zb_spec.name） */
export function listGoodsSpecGoodSpecOptions(query) {
  return request({
    url: '/user/goods-spec/good-spec-options',
    method: 'get',
    params: query
  })
}

// 查询产品规格分页
export function pageGoodsSpec(query) {
  return request({
    url: '/user/goods-spec/page',
    method: 'get',
    params: query
  })
}

// 查询产品规格详细
export function getGoodsSpec(data) {
  return request({
    url: '/user/goods-spec/detail',
    method: 'get',
    params: data
  })
}

// 新增产品规格
export function addGoodsSpec(data) {
  return request({
    url: '/user/goods-spec/add',
    method: 'post',
    data: data
  })
}

// 修改产品规格
export function updateGoodsSpec(data) {
  return request({
    url: '/user/goods-spec/edit',
    method: 'post',
    data: data
  })
}

// 删除产品规格
export function delGoodsSpec(data) {
  return request({
    url: '/user/goods-spec/delete',
    method: 'post',
    data: data
  })
}
